import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import ModelBase from 'app/models/base';

export const DestinationReliability = ModelBase.extend({});

export default PageableBase.extend({
  model: DestinationReliability,
  key: 'destinations_reliabilities',
  url: analyticsUrl('tracking/v2/carriers/destinations_reliability'),
  pagingType: PAGING_TYPES.PER_PAGE,

  initialize(models, { dateRange, carrierSelection, servicePrioritySelection, destinationLevelSelection }) {
    this.dateRange = dateRange;
    this.carrierSelection = carrierSelection;
    this.servicePrioritySelection = servicePrioritySelection;
    this.destinationLevelSelection = destinationLevelSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.carrierSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.servicePrioritySelection, 'change', this.resetToFirstPage);
    this.listenTo(this.destinationLevelSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      start_date: this.dateRange.getStartDatetimeForParam().format('YYYY-MM-DD'),
      end_date: this.dateRange.getEndDatetimeForParam().format('YYYY-MM-DD'),
      ...this.carrierSelection.getParams(),
      ...this.servicePrioritySelection.getParams(),
      ...this.destinationLevelSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/destination_reliabilities.js